import * as types from '../action-types';

type openProps = {
  isOpen: boolean;
  top: number;
  left: number;
};

export const openFeedbackPopover = (data: openProps) =>
  <const>{
    type: types.openFeedbackPopover,
    payload: { data },
  };

export const closeFeedbackPopover = () => {
  return <const>{
    type: types.closeFeedbackPopover,
  };
};

export type FeedbackActions = ReturnType<
  typeof openFeedbackPopover | typeof closeFeedbackPopover
>;
